import { MeetingLeftPage } from '@/components/templates/MeetingLeftPage/MeetingLeftPage'

export function VideoMeetingLeftPage() {
  return <MeetingLeftPage meetingType="video" />
}
